import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
// import { AuthService } from '../../services/auth.service';
import { authActions } from './auth.actions';
import { catchError, exhaustMap, map, of } from 'rxjs';
// import { IdentityService } from '../../api/services';

export const loginEffect = createEffect(
  (
    actions$ = inject(Actions),
    // identity = inject(IdentityService),
    // auth = inject(AuthService)
  ) => {
    return of(authActions.login_fail());
    // return actions$.pipe(
    //   ofType(authActions.login),
    //   exhaustMap((props) =>
    //     identity
    //       .identityControllerLogin({
    //         body: { email: props.email, password: props.password },
    //       })
    //       .pipe(
    //         map((r) => {
    //           auth.storeUser(r.data.access_token); // Should I store the user to the store?
    //           return authActions.login_success(r.data);
    //         }),
    //         catchError((error: { message: string }) =>
    //           of(authActions.login_fail())
    //         )
    //       )
    //   )
    // );
  },
  { functional: true },
);
